import { en, type Code } from './en';

type Vars = Record<string, string | number>;

/** The language in use, for what Intl sorts or formats (the members' list): English until Phase H. */
export const LOCALE = 'en';

/** The text of a code in the language in use (English until Phase H), with its variables filled. */
export function t(code: Code, vars?: Vars): string {
  const text: string = en[code];
  if (!vars) return text;
  return text.replace(/\{(\w+)\}/g, (match, name: string) =>
    name in vars ? String(vars[name]) : match,
  );
}

export type { Code };
